module.exports = __webpack_public_path__ + "static/BannerOurVision2x-1c179cb15fac13f141acc76c9ee76aa7.jpg";